'use strict';

angular.module('DoohApps')
.filter('sortInfoFilter', function () {
    return function (currentSortValue) {
        // 1 - data is currently sorted in asc order
        // 2 - data is currently sorted in desc order
        // 0 - data currently isn't sorted by this filter. By default we start sorting in asc order
        switch (currentSortValue) {
            case 1:
                return 'Sort descending';
            case 0:
            case 2:
                return 'Sort ascending';
            default: return 'Sort ascending';
        }
    }
});